var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartnerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8841 17.1921C12.5494 17.1921 12.2792 16.8818 12.2792 16.4973V14.1673C12.2792 11.6011 10.4605 9.5166 8.2305 9.5166H5.26252C3.02847 9.5166 1.20977 11.6011 1.20977 14.1673V16.4973C1.20977 16.8818 0.939591 17.1921 0.604887 17.1921C0.270183 17.1921 0 16.8818 0 16.4973V14.1673C0 10.8368 2.35906 8.12695 5.25849 8.12695H8.22647C11.1259 8.12695 13.485 10.8368 13.485 14.1673V16.4973C13.489 16.8818 13.2188 17.1921 12.8841 17.1921Z",
    fill: "#768396"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74154 7.01919C5.10432 7.01919 3.76953 5.48595 3.76953 3.6053C3.76953 1.72465 5.10432 0.191406 6.74154 0.191406C8.37877 0.191406 9.71356 1.72001 9.71356 3.6053C9.71356 5.49058 8.3828 7.01919 6.74154 7.01919ZM6.74154 1.58105C5.76969 1.58105 4.97931 2.48895 4.97931 3.6053C4.97931 4.72164 5.76969 5.62954 6.74154 5.62954C7.7134 5.62954 8.50378 4.72164 8.50378 3.6053C8.50378 2.48895 7.7134 1.58105 6.74154 1.58105Z",
    fill: "#768396"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerIcon);
export default __webpack_public_path__ + "static/media/partnerIcon.4c67a5775568c316c8f4ca349f78b191.svg";
export { ForwardRef as ReactComponent };